import * as React from 'react';
import styled from 'styled-components';
import { isSearchEnhancementsMilestone1Enabled } from 'feature-flags';
import { useIntl } from 'react-intl-next';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import ActivityIcon from '@atlaskit/icon/glyph/activity';
import SendIcon from '@atlaskit/icon/glyph/send';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { AutoScaledImage } from '@atlassian/help-center-common-component/auto-scaled-image';
import type { SearchProps } from '@atlassian/help-center-common-component/result-base';
import { SearchResultBase, emphasizeAndEscapeText } from '@atlassian/help-center-common-component/result-base';
import messages from './messages';

interface Props extends SearchProps {
    id: number;
    searchTerm: string;
    portalId: number;
    name: string;
    portalName: string;
    iconUrl?: string;
}

const ImageIcon = ({ iconUrl, name }: { iconUrl: string; name: string }) =>
    isSearchEnhancementsMilestone1Enabled() ? (
        <AutoScaledImage src={iconUrl} alt={name} />
    ) : (
        <Image src={iconUrl} alt={name} />
    );

const SearchResultRequest = ({ name, id, portalId, iconUrl, portalName, ...props }: Props) => {
    const { formatMessage } = useIntl();

    return (
        <AnalyticsContext data={{ attributes: { portalId, requestTypeId: id } }}>
            <SearchResultBase
                actionSubjectId="requestType"
                elevated
                leftIcon={
                    iconUrl ? <ImageIcon iconUrl={iconUrl} name={name} /> : <ActivityIcon label="" size="medium" />
                }
                rightIcon={<SendIcon label="" size="small" primaryColor={token('color.icon', colors.N300)} />}
                titleHtml={emphasizeAndEscapeText(name, props.searchTerm)}
                subtitle={formatMessage(messages.to, { portalName })}
                to={`/portal/${portalId}/create/${id}`}
                {...props}
            />
        </AnalyticsContext>
    );
};

export default SearchResultRequest;

const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;
